import { useQuery } from '@tanstack/react-query';

import { kinds, type EnvKey } from '@/app/site/scope';
import { contentTypesList, schemaTransferPreview } from '@/shared/api/generated/content/content';

/** Типы окружения — модели и компоненты; trash — корзина. */
export function useSchemaTypes(siteId: string, env: EnvKey, trash = false) {
  return useQuery({
    queryKey: ['content-types', siteId, env, ...(trash ? ['trash'] : [])],
    queryFn: async () => {
      const response = await contentTypesList(siteId, kinds[env], trash ? { deleted: true } : {});

      if (response.status !== 200) {
        throw new Error('Неожиданный ответ на запрос моделей');
      }

      return response.data.items ?? [];
    },
  });
}

/**
 * Сколько изменений схемы этого окружения ещё нет в другом — число на кнопке
 * «Перенос» (вместо плашки, по просьбе Давида).
 */
export function usePendingTransfer(siteId: string, env: EnvKey) {
  const from = kinds[env];
  const to = from === 'production' ? 'development' : 'production';

  const query = useQuery({
    queryKey: ['schema-transfer', siteId, from, to],
    queryFn: async () => {
      const response = await schemaTransferPreview(siteId, { from, to });

      return response.status === 200 ? (response.data.changes?.length ?? 0) : 0;
    },
  });

  return query.data ?? 0;
}

/** Модель «Страницы» — живёт в своём разделе, а не среди моделей. */
export const PAGES_SLUG = 'pages';
